import type { FormKitNode } from '@formkit/core'

export default (node: FormKitNode): boolean => {
  const value = String(node.value)
  const regex = /^\+(?:[0-9] ?){6,14}[0-9]$/

  return regex.test(value)
}
